import React, { useEffect, useRef, useState } from "react";
import "./signup.css";
import logo from "../../assets/signup/Group 1000008451 (1) 1 (1).svg";
import lockimg from "../../assets/signup/image 3037 (1).svg";
import SuccessComponent from "../../Components/SuccessComponent/SuccessComponent";
import { useNavigate } from "react-router-dom";

function Signup() {
  const [formData, setFormData] = useState({
    fullname: "",
    phone: "",
    email: "",
    title: "",
    companyName: "",
  });
  const [loading, setLoading] = useState(false);
  const popupRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/Plan");
  };
  // useEffect(() => {
  //   let userUuid = sessionStorage.getItem("userUuid");
  //   if (!userUuid) {
  //     userUuid = generateUUID();
  //     sessionStorage.setItem("userUuid", userUuid);
  //     console.log("Generated UUID:", userUuid);
  //   }
  // }, []);
  // const generateUUID = () => {
  //   return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
  //     const r = (Math.random() * 16) | 0;
  //     const v = c === "x" ? r : (r & 0x3) | 0x8;
  //     return v.toString(16);
  //   });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const scriptURL =
      "https://script.google.com/macros/s/AKfycbwNXhvUzxfnWMMRUlrl0yngKWWkzXTYW7kRYcHajEG4DSTw5gZkMQ0XjjTilTqYyjBB3g/exec";
    setLoading(true);
    try {
      const todayDate = new Date()
      const formPayload = new FormData();
      // Add form data to the payload
      for (let key in formData) {
        formPayload.append(key, formData[key]);
      }
      formPayload.append("Date", todayDate)
      // Retrieve the UUID from sessionStorage
      const userUuid = sessionStorage.getItem("userUuid");
      console.log("Retrieved UUID from sessionStorage:", userUuid);
      if (userUuid) {
        formPayload.append("uuid", userUuid);
      }
  
      // Retrieve the selected plan from sessionStorage
      const selectedPlan = JSON.parse(sessionStorage.getItem("selectedPlan"));
  
      if (selectedPlan) {
        // If selectedPlan exists, append it and submit the form
        formPayload.append("selectedPlan", selectedPlan);
        
        // Proceed with form submission
        const response = await fetch(scriptURL, {
          method: "POST",
          body: formPayload, // No 'Content-Type' header for FormData
        });
  
        if (response.ok) {
          // Reset form data
          setFormData({
            fullname: "",
            phone: "",
            email: "",
            title: "",
            companyName: "",
            selectedPlan: "",
          });
  
          // Show success message and navigate if necessary
          popupRef.current.showPopup(
            "Successfully Signed Up! Our executive will contact you shortly.",
            "bi bi-check-circle-fill"
          );
          
          // setTimeout(() => {
          //   handleNavigate();
          // }, 2000);
        } else {
          alert("Something went wrong. Please try again.");
        }
      } else {
        // If no plan is selected, store the form data in sessionStorage and navigate to the Plan page
        sessionStorage.setItem("signupFormData", JSON.stringify(formData));
  
        // Navigate to the plan page so the user can select a plan
        handleNavigate();
      }
    } catch (error) {
      console.error("Error:", error);
      popupRef.current.showPopup("Sign up Failed", "bi bi-x-circle-fill");
    } finally {
      setLoading(false);
    }
  };
  
 
 
  // const getUuidFromSheet = async () => {
  //   try {
  //     const scriptURL = "https://script.google.com/macros/s/AKfycbwNXhvUzxfnWMMRUlrl0yngKWWkzXTYW7kRYcHajEG4DSTw5gZkMQ0XjjTilTqYyjBB3g/exec"; // Replace with your actual Google Script URL
  //     const response = await fetch(scriptURL);
      
  //     if (response.ok) {
  //       const data = await response.json();
  //       const uuid = data.uuid; // Get UUID from the response
  //       console.log("UUID from Google Sheets:", uuid);
  //       sessionStorage.setItem("userUuid", uuid); // Store UUID in local storage
  //     } else {
  //       console.error("Error fetching UUID:", response.statusText);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching UUID:", error);
  //   }
  // };
  
  // // Call the function when needed, for example on form submission or page load
  // useEffect(() => {
  //   getUuidFromSheet();
  // }, []);
  

  
  return (
    <div className="s_outer">
      <div className="signup_outer">
        <div className="signup_outer_inner">
          <div className="signup_left">
            <form action="" onSubmit={handleSubmit} name="google-sheet">
              <h1>SIGNUP</h1>
              <div className="signup_input_items">
                <label htmlFor="">Full name</label>
                <input
                  type="text"
                  className="input"
                  required
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                />
                <label htmlFor="">Company Name</label>
                <input
                  type="text"
                  className="input"
                  required
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                />
                <label htmlFor="">Title</label>
                <input
                  type="text"
                  className="input"
                  required
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                />
                <label htmlFor="">Email Id</label>
                <div className="signup_input">
                  <input
                    type="Email"
                    className="signup_input_field"
                    required
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {/* <p>verify</p> */}
                </div>
                <label htmlFor="">Phone number</label>
                <div className="signup_input">
                  <input
                    type="number"
                    className="signup_input_field"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                  {/* <p>verify</p> */}
                </div>
                {/* <label htmlFor="">Password</label>
                <input
                  type="password"
                  className="input"
                  required
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <label htmlFor="">Confirm Password</label>
                <input
                  type="password"
                  className="input"
                  required
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                /> */}

                <div className="signup_button" type="submit">
                  <button type="submit" disabled={loading}>
                    {loading ? <span className="loader"></span> : "Sign Up"}
                  </button>{" "}
                </div>
              </div>
            </form>
          </div>
          <div className="signup_right">
            <img src={logo} alt="" className="logo" />
            <img src={lockimg} alt="" className="lockimg" />
          </div>
        </div>
      </div>
      <SuccessComponent ref={popupRef} />
    </div>
  );
}

export default Signup;
